import { createPublicClient, createWalletClient, http } from 'viem';
import { privateKeyToAccount } from 'viem/accounts';
import { to0xString } from './toHex';

// 创建钱包客户端
export function createViemWallet(privateKey: string, chain, rpc: string) {
    const account = privateKeyToAccount(to0xString(privateKey));
    const walletClient = createWalletClient({
        account,
        chain,
        transport: http(rpc) // 或者使用你的 RPC URL
    });
    const publicClient = createPublicClient({
        chain: chain,
        transport: http(rpc)
    })

    return { walletClient, publicClient };
}

